import { EN_COMMON } from "./common/en";
import { Common } from "./common/type";
import { VI_COMMON } from "./common/vi";
import { EN_EVENT_CATEGORY } from "./eventCategory/en";
import { EventCategory } from "./eventCategory/type";
import { VI_EVENT_CATEGORY } from "./eventCategory/vi";

type Locale = {
  common: Common;
  event: {
    category: EventCategory;
  };
};

export const EN: Locale = {
  common: EN_COMMON,
  event: { category: EN_EVENT_CATEGORY }
};
export const VI: Locale = {
  common: VI_COMMON,
  event: { category: VI_EVENT_CATEGORY }
};
